import type { Routes } from '@angular/router';
import { secureRoute } from './core/utils/transformers';
import { ProcedureCreateComponent } from './features/procedures/pages/procedure-create/procedure-create';
import { ProcedureDetailsComponent } from './features/procedures/pages/procedure-details/procedure-details';
import { ProcedureEditComponent } from './features/procedures/pages/procedure-edit/procedure-edit';
import { ProceduresViewComponent } from './features/procedures/pages/procedure-view/procedures-view';

export const procedureRoutes: Routes = [
  secureRoute({
    path: 'procedures',
    component: ProceduresViewComponent,
    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'procedury',
          isCurrent: true,
          url: '/procedures',
        },
      ],
    },
  }),
  secureRoute({
    path: 'procedure/:id/details',
    component: ProcedureDetailsComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'procedury',
          isCurrent: false,
          url: '/procedures',
        },
        {
          id: 1,
          label: 'detale',
          isCurrent: true,
          url: '/procedure/:id/details',
        },
      ],
    },
  }),
  secureRoute({
    path: 'procedure/:id/edit',
    component: ProcedureEditComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'procedury',
          isCurrent: false,
          url: '/procedures',
        },
        {
          id: 1,
          label: 'edycja',
          isCurrent: true,
          url: '/procedure/:id/edit',
        },
      ],
    },
  }),
  secureRoute({
    path: 'procedure/create',
    component: ProcedureCreateComponent,

    data: {
      roles: ['mhs.scmmanager.user'],
      breadcrumbs: [
        {
          id: 0,
          label: 'procedury',
          isCurrent: false,
          url: '/procedures',
        },
        {
          id: 1,
          label: 'dodawanie',
          isCurrent: true,
          url: '/procedure/create',
        },
      ],
    },
  }),
];
